import React, { useEffect } from "react";

import "./portal.scss"

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome3: React.FC = () => {

  const [tabIndex, setTabIndex] = React.useState<string>('home');

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: 'Walter White',
      consultorio: 'Av. Spinetto 670, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-123456',
      matricula: '1234',
      cuit: '20-12345678-9',
      especialidades: ['Fonoaudiología', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Sarah Jhonson',
      consultorio: 'Belgrano 123, General Pico',
      localidad: 'General Pico',
      telefono: '2954-654321',
      matricula: '5678',
      cuit: '27-87654321-0',
      especialidades: ['Voz', 'Lenguaje'],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'William Anderson',
      consultorio: 'Rivadavia 456, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-789012',
      matricula: '9101',
      cuit: '23-11223344-5',
      especialidades: ['Odontoesmatología', 'Deglución'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Amanda Jepson',
      consultorio: 'San Martín 789, Toay',
      localidad: 'Toay',
      telefono: '2954-345678',
      matricula: '1121',
      cuit: '27-55667788-1',
      especialidades: ['Rehabilitación', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: 'Lucía Fernández',
      consultorio: 'Av. Luro 1500, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-111222',
      matricula: '2233',
      cuit: '27-33445566-2',
      especialidades: ['Lenguaje', 'Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/luciaf',
        instagram: 'https://instagram.com/luciaf',
        linkedin: '',
      },
    },
    {
      nombre: 'Martín Gómez',
      consultorio: 'Calle 9 N° 456, General Pico',
      localidad: 'General Pico',
      telefono: '2954-333444',
      matricula: '3344',
      cuit: '20-99887766-3',
      especialidades: ['Audiología'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/mgomez',
        facebook: '',
        instagram: '',
        linkedin: 'https://linkedin.com/in/mgomez',
      },
    },
    {
      nombre: 'Paula Sosa',
      consultorio: 'Av. Perón 234, Toay',
      localidad: 'Toay',
      telefono: '2954-555666',
      matricula: '4455',
      cuit: '23-44556677-8',
      especialidades: ['Voz', 'Rehabilitación'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: '',
        instagram: 'https://instagram.com/paulasosa',
        linkedin: '',
      },
    },
    {
      nombre: 'Federico Ruiz',
      consultorio: 'Mitre 800, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-777888',
      matricula: '5566',
      cuit: '20-22334455-6',
      especialidades: ['Odontoesmatología', 'Lenguaje', 'Deglución'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/federicoruiz',
        facebook: '',
        instagram: '',
        linkedin: '',
      },
    },
    {
      nombre: 'María López',
      consultorio: 'Calle 25 N° 100, General Pico',
      localidad: 'General Pico',
      telefono: '2954-999000',
      matricula: '6677',
      cuit: '27-77889900-1',
      especialidades: ['Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/marialopez',
        instagram: '',
        linkedin: '',
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState('');
  const [filtroLocalidad, setFiltroLocalidad] = React.useState('');
  const [filtroObraSocial, setFiltroObraSocial] = React.useState('');
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState('');

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(new Set(profesionalesData.map(p => p.localidad)));
  const especialidades = Array.from(new Set(profesionalesData.flatMap(p => p.especialidades)));

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter(p => {
    const matchNombre = p.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) || 
                       p.matricula.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === 'si' && p.atiendeObraSocial) ||
      (filtroObraSocial === 'no' && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad;
  });

  useEffect(() => {
  if (tabIndex === 'institucional' && window.PureCounter) {
    new window.PureCounter();
  }
}, [tabIndex]);

  useEffect(() => {
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      './assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js',
      './assets/portal/vendor/php-email-form/validate.js',
      './assets/portal/vendor/aos/aos.js',
      './assets/portal/vendor/glightbox/js/glightbox.min.js',
      './assets/portal/vendor/purecounter/purecounter_vanilla.js',
      './assets/portal/js/main.js',
    ];
    const scriptElements = scripts.map(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: 'https://fonts.googleapis.com', rel: 'preconnect' },
      { href: 'https://fonts.gstatic.com', rel: 'preconnect', crossorigin: 'anonymous' },
      { href: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', rel: 'stylesheet' },
      { href: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap', rel: 'stylesheet' }
    ];
    const linkElements = fontLinks.map(props => {
      const link = document.createElement('link');
      Object.entries(props).forEach(([key, value]) => link.setAttribute(key, value));
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      '/assets/portal/vendor/bootstrap/css/bootstrap.min.css',
      '/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css',
      '/assets/portal/vendor/aos/aos.css',
      '/assets/portal/vendor/fontawesome-free/css/all.min.css',
      '/assets/portal/vendor/glightbox/css/glightbox.min.css',
      '/assets/portal/vendor/swiper/swiper-bundle.min.css',
      '/assets/portal/css/main.css',
    ];
    const cssElements = cssLinks.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach(script => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER - ESTILO MÉDICO PROFESIONAL */}
      <header id="header" className="header sticky-top">
        <div className="topbar d-flex align-items-center" style={{
          background: 'linear-gradient(135deg, rgba(76, 204, 244, 0.95) 0%, rgba(59, 130, 246, 0.95) 50%, rgba(99, 179, 237, 0.95) 100%)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 2px 20px rgba(0, 0, 0, 0.1)',
          padding: '10px 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Elemento decorativo de fondo */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%)
            `,
            zIndex: 1
          }} />
          
          <div className="container d-flex justify-content-center justify-content-md-between" style={{
            position: 'relative',
            zIndex: 2
          }}>
            <div className="d-none d-md-flex align-items-center" style={{
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500',
              fontFamily: "'Poppins', sans-serif",
              textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
              letterSpacing: '0.3px'
            }}>
              <i className="bi bi-building me-2" style={{
                fontSize: '1rem',
                color: '#ffd700'
              }}></i> 
              Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <a 
              href="https://wa.me/5429542954702284?text=Hola,%20necesito%20información%20sobre%20los%20servicios%20del%20Colegio%20de%20Fonoaudiólogos" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{
                color: '#ffffff',
                fontSize: '0.9rem',
                fontWeight: '500',
                fontFamily: "'Poppins', sans-serif",
                textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                letterSpacing: '0.3px',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                padding: '5px 10px',
                borderRadius: '25px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(5px)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(37, 211, 102, 0.2)';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(37, 211, 102, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <i className="bi bi-whatsapp me-2" style={{
                fontSize: '1rem',
                color: '#25d366',
                animation: 'topbarPulse 2s infinite'
              }}></i> 
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a href="index.html" className="logo d-flex align-items-center me-auto">
              <img src="assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li><a href="#" className="active" onClick={() => setTabIndex('home')}>Inicio</a></li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('institucional')}><span>Institucional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Quiénes somos?</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Directiva</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Tribunal de Ética y Disciplina</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Revisora de Cuentas</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href="#" onClick={() => setTabIndex('tramites')}><span>Trámites</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#" onClick={() => setTabIndex('matriculacion')}>Matriculación</a></li>
                    <li><a href="#" onClick={() => setTabIndex('consultorio')}>Consultorio</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Título</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Baja de Matrícula</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}><span>Ejercicio Profesional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Honorarios Mínimos</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Código de Ética</a></li>
                    <li><a href="#" onClick={() => setTabIndex('certificado-etica')}>Certificado de Ética</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Consentimiento Informado</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li><a href="#" onClick={() => setTabIndex('profesionales')}>Profesionales</a></li>
                <li><a href="#">Obras Sociales</a></li>
                <li><a href="#" onClick={() => setTabIndex('contacto')}>Contacto</a></li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a className="cta-btn" href="http://145.223.94.120/" target="_blank" rel="noopener noreferrer">AUTOGESTION</a>
          </div>
        </div>
      </header>
      
      
      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === 'home' && (
          <>
            <section id="hero" className="hero section" style={{
              position: 'relative',
              height: '400px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #4cccf4 0%, #3b82f6 25%, #60a5fa 50%, #06b6d4 75%, #4cccf4 100%)',
              backgroundSize: '400% 400%',
              animation: 'gradientShift 15s ease infinite',
              overflow: 'hidden',
            }}>
              
              {/* Elementos de fondo modernos similares al PortalHome original */}
              
              {/* Ondas animadas de fondo */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: `
                  radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 75% 75%, rgba(76, 204, 244, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 50% 50%, rgba(96, 165, 250, 0.05) 0%, transparent 50%)
                `,
                zIndex: 1
              }} />
              
              {/* Patrón geométrico animado */}
              <div style={{
                position: 'absolute',
                top: '-50%',
                left: '-50%',
                width: '200%',
                height: '200%',
                backgroundImage: `
                  linear-gradient(45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(-45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%),
                  linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%)
                `,
                backgroundSize: '60px 60px',
                backgroundPosition: '0 0, 0 30px, 30px -30px, -30px 0px',
                animation: 'patternFloat 20s linear infinite',
                zIndex: 2
              }} />
              
              {/* Círculos flotantes */}
              <div style={{
                position: 'absolute',
                top: '10%',
                right: '15%',
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(76, 204, 244, 0.1))',
                backdropFilter: 'blur(10px)',
                animation: 'floatUpDown 6s ease-in-out infinite',
                zIndex: 2
              }} />
              
              <div style={{
                position: 'absolute',
                bottom: '10%',
                left: '10%',
                width: '200px',
                height: '200px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(96, 165, 250, 0.1), rgba(59, 130, 246, 0.1))',
                backdropFilter: 'blur(10px)',
                animation: 'floatUpDown 8s ease-in-out infinite reverse',
                zIndex: 2
              }} />
              
              {/* Triángulos decorativos */}
              <div style={{
                position: 'absolute',
                top: '20%',
                left: '5%',
                width: '100px',
                height: '100px',
                background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1), transparent)',
                clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
                animation: 'rotateFloat 12s linear infinite',
                zIndex: 2
              }} />
              
              <div style={{
                position: 'absolute',
                bottom: '15%',
                right: '8%',
                width: '80px',
                height: '80px',
                background: 'linear-gradient(45deg, rgba(76, 204, 244, 0.15), transparent)',
                clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
                animation: 'rotateFloat 10s linear infinite reverse',
                zIndex: 2
              }} />
              
              {/* Overlay principal con textura */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: `
                  linear-gradient(135deg, 
                    rgba(76, 204, 244, 0.8) 0%, 
                    rgba(59, 130, 246, 0.7) 25%,
                    rgba(96, 165, 250, 0.6) 50%,
                    rgba(6, 182, 212, 0.7) 75%,
                    rgba(76, 204, 244, 0.8) 100%
                  )
                `,
                backdropFilter: 'blur(1px)',
                zIndex: 3
              }} />
              {/* Contenido principal */}
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'relative',
                zIndex: 4,
                padding: '60px 0'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '55%',
                  height: '100%',
                  gap: '20px',
                  position: 'relative'
                }}>
                  
                  <img
                    src="/assets/portal/img/logo_1.svg"
                    alt="Logo Cofolp Parte 1"
                    className="logo-animation logo-1"
                    style={{
                      height: '200px',
                      objectFit: 'contain',
                      filter: 'drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2))',
                      display: 'block',
                      opacity: 0,
                      transform: 'translateY(20px)',
                      animation: 'scaleIn 1s ease-out 0.3s forwards'
                    }}
                  />
                  
                  <img
                    src="/assets/portal/img/logo_2.svg"
                    alt="Logo Cofolp Parte 2"
                    className="logo-animation logo-2"
                    style={{
                      height: '200px',
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1) drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2))',
                      display: 'block',
                      opacity: 0,
                      transform: 'translateY(20px)',
                      animation: 'scaleIn 1s ease-out 0.6s forwards'
                    }}
                  />
                </div>
                <div
                  className="banner-text"
                  style={{
                    width: '45%',
                    height: 'auto',
                    maxWidth: '600px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 30px',
                    margin: '20px',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.08)',
                    position: 'relative',
                    overflow: 'hidden',
                    opacity: 0,
                    transform: 'translateY(30px)',
                    animation: 'slideInUp 1.2s ease-out 0.8s forwards'
                  }}
                >
                  {/* Elemento decorativo de fondo */}
                  <div style={{
                    position: 'absolute',
                    top: '-50%',
                    right: '-30%',
                    width: '200px',
                    height: '200px',
                    background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1), transparent)',
                    borderRadius: '50%',
                    zIndex: 1
                  }} />
                  
                  {/* Contenido del texto */}
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <h2 style={{
                      color: '#ffffff',
                      fontSize: '2.4rem',
                      fontWeight: '700',
                      lineHeight: '1.2',
                      textShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                      margin: 0,
                      fontFamily: "'Poppins', sans-serif",
                      letterSpacing: '-0.5px',
                      marginBottom: '12px'
                    }}>
                      El respaldo de la<br />
                      <span style={{
                        background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #fff2a1 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        fontWeight: '800',
                        fontSize: '2.6rem'
                      }}>
                        Fonoaudiología
                      </span>
                      <br />en La Pampa
                    </h2>
                    
                    <div style={{
                      width: '60px',
                      height: '3px',
                      background: 'linear-gradient(90deg, #ffd700, #ffed4e)',
                      margin: '20px auto',
                      borderRadius: '2px'
                    }} />
                    
                    <p style={{
                      fontSize: '1.3rem',
                      fontWeight: '500',
                      color: 'rgba(255, 255, 255, 0.95)',
                      margin: 0,
                      fontFamily: "'Poppins', sans-serif",
                      letterSpacing: '0.3px',
                      textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                    }}>
                      Regulación • Formación • Ética
                    </p>
                  </div>
                </div>
              </div>
              
              <style>{`
                /* Animaciones similares al PortalHome original */
                @keyframes fadeInUp {
                  0% {
                    opacity: 0;
                    transform: translateY(20px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
                
                @keyframes scaleIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
                
                @keyframes slideInUp {
                  0% {
                    opacity: 0;
                    transform: translateY(30px) scale(0.95);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes gradientShift {
                  0% {
                    background-position: 0% 50%;
                  }
                  25% {
                    background-position: 50% 25%;
                  }
                  50% {
                    background-position: 100% 50%;
                  }
                  75% {
                    background-position: 50% 75%;
                  }
                  100% {
                    background-position: 0% 50%;
                  }
                }
                
                @keyframes topbarPulse {
                  0%, 100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                  50% {
                    opacity: 0.8;
                    transform: scale(1.05);
                  }
                }
                
                @keyframes patternFloat {
                  0% {
                    transform: translateX(0) translateY(0) rotate(0deg);
                  }
                  25% {
                    transform: translateX(-10px) translateY(-15px) rotate(90deg);
                  }
                  50% {
                    transform: translateX(0) translateY(-30px) rotate(180deg);
                  }
                  75% {
                    transform: translateX(10px) translateY(-15px) rotate(270deg);
                  }
                  100% {
                    transform: translateX(0) translateY(0) rotate(360deg);
                  }
                }
                
                @keyframes floatUpDown {
                  0%, 100% {
                    transform: translateY(0px);
                  }
                  50% {
                    transform: translateY(-20px);
                  }
                }
                
                @keyframes rotateFloat {
                  0% {
                    transform: rotate(0deg) translateY(0px);
                  }
                  50% {
                    transform: rotate(180deg) translateY(-15px);
                  }
                  100% {
                    transform: rotate(360deg) translateY(0px);
                  }
                }
                
                /* Responsive similar al PortalHome original */
                @media (max-width: 768px) {
                  .topbar {
                    padding: 8px 0 !important;
                    font-size: 0.8rem !important;
                  }
                  
                  .topbar .container > div {
                    font-size: 0.85rem !important;
                  }
                  
                  #hero {
                    min-height: 400px !important;
                    padding: 40px 0 !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    flex-direction: column !important;
                    gap: 15px !important;
                    padding: 0 20px !important;
                    max-width: none !important;
                    justify-content: center !important;
                    align-items: center !important;
                  }
                  
                  .logo-1 {
                    display: none !important;
                  }
                  
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 160px !important;
                    max-width: 95% !important;
                    object-fit: contain !important;
                  }
                }
                
                @media (max-width: 600px) {
                  #hero {
                    min-height: 350px !important;
                    padding: 30px 0 !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 15px !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    padding-left: 15px !important;
                    gap: 12px !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  .logo-1 {
                    display: none !important;
                  }
                  
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 130px !important;
                    max-width: 90% !important;
                    object-fit: contain !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                }
                
                @media (max-width: 480px) {
                  #hero {
                    min-height: 320px !important;
                    padding: 20px 0 !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 10px !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    gap: 10px !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  .logo-1 {
                    display: none !important;
                  }
                  
                  #hero > div:last-child > div:first-child img.logo-2 {
                    height: 110px !important;
                    max-width: 90% !important;
                    object-fit: contain !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                }
              `}</style>
            </section>

            {/* Featured Services Section - ESTILO SIMILAR AL PORTAL ORIGINAL */}
            <section id="featured-services" className="featured-services section" style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              padding: '40px 0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Elementos decorativos de fondo similares al original */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '300px',
                height: '300px',
                background: 'linear-gradient(135deg, rgba(76, 204, 244, 0.1), rgba(59, 130, 246, 0.1))',
                borderRadius: '50%',
                zIndex: 1
              }} />
              <div style={{
                position: 'absolute',
                bottom: '-100px',
                left: '-100px',
                width: '400px',
                height: '400px',
                background: 'linear-gradient(135deg, rgba(96, 165, 250, 0.1), rgba(6, 182, 212, 0.1))',
                borderRadius: '50%',
                zIndex: 1
              }} />

              <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                <div className="row gy-4 justify-content-center">
                  {/* Servicio 1: Acceso a AUTOGESTION */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(76, 204, 244, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(76, 204, 244, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                    }}
                    onClick={() => window.open('http://145.223.94.120/', '_blank')}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(76, 204, 244, 0.2), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #4cccf4, #3b82f6)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(76, 204, 244, 0.4)'
                        }}>
                          <i className="fas fa-laptop-code" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Acceso a AUTOGESTION
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Gestione sus trámites, consulte su estado de cuenta y acceda a todos los servicios digitales del colegio.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #4cccf4, #3b82f6)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Ingresar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 2: Buscar Fonoaudiólogo */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(96, 165, 250, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                    }}
                    onClick={() => setTabIndex('profesionales')}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(96, 165, 250, 0.2), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #60a5fa, #3b82f6)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(96, 165, 250, 0.4)'
                        }}>
                          <i className="fas fa-user-md" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Buscar Fonoaudiólogo
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Encuentre profesionales matriculados por especialidad, localidad y cobertura de obra social.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #60a5fa, #3b82f6)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Buscar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 3: Próximos Cursos y Eventos */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(6, 182, 212, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                    }}
                    onClick={() => {
                      alert('Sección de Cursos y Eventos próximamente disponible');
                    }}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(6, 182, 212, 0.2), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(6, 182, 212, 0.4)'
                        }}>
                          <i className="fas fa-graduation-cap" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Próximos Cursos y Eventos
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Manténgase actualizado con los últimos cursos, seminarios y eventos de formación profesional.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #06b6d4, #3b82f6)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Ver Eventos →
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Estilos CSS similares al PortalHome original */}
              <style>{`
                .modern-service-card:hover .service-icon {
                  transform: scale(1.1) rotate(5deg);
                  transition: all 0.3s ease;
                }
                
                @media (max-width: 768px) {
                  .modern-service-card {
                    min-height: 280px !important;
                    padding: 30px 20px !important;
                  }
                  
                  .modern-service-card h4 {
                    font-size: 1.2rem !important;
                  }
                  
                  .service-icon {
                    width: 70px !important;
                    height: 70px !important;
                  }
                  
                  .service-icon i {
                    font-size: 1.7rem !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .modern-service-card {
                    margin: 10px !important;
                    min-height: 260px !important;
                  }
                }
              `}</style>
            </section>
          </>
        )}

        {/* Resto de secciones iguales al PortalHome original... */}
        {tabIndex === 'institucional' && (
          <>
           {/* Stats Section */}
            <section id="stats" className="stats section" style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
              color: '#e2e8f0'
            }}>
              <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === 'profesionales' && (
          <div className="profesionales">
            <section id="profesionales" className="professionals section" style={{
              background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
              padding: '80px 0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Grid médico de fondo */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `
                  linear-gradient(rgba(59, 130, 246, 0.02) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(59, 130, 246, 0.02) 1px, transparent 1px)
                `,
                backgroundSize: '30px 30px',
                zIndex: 1
              }} />
              
              {/* Aquí iría el contenido de la sección de profesionales */}
            </section>
          </div>
        )}
      </main>
      
      {/* FOOTER - ESTILO SIMILAR AL PORTAL ORIGINAL */}
      <footer id="footer" className="footer">
        <div className="container">
          <div className="copyright text-center">
            <p>© <span>Copyright</span> <strong className="px-1 sitename">COFOLP</strong> <span>All Rights Reserved</span></p>
          </div>
          <div className="credits">
            Designed by <a href="#">COFOLP</a>
          </div>
        </div>
      </footer>
      
      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    </>
  );
};
